import * as React from 'react';
import { Dispatch } from 'redux';
import { AddUnknownParticipantRequest } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class AddUnknownEventParticipantRequest extends BaseApiPostRequest<
  AddUnknownParticipantRequest,
  EntityNormalizers.NormalizedEntity<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(eventId: string, formData: AddUnknownParticipantRequest, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/events/${eventId}/unknown-participants`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipant;
  }
}
